
import {serializable, alias, object, list, primitive} from 'serializr';

export class StudentStatusModel { 

	@serializable(alias('totalStudent', primitive()))
	totalStudents?: number;

	@serializable(alias('totalStudentLogin', primitive()))
	totalActiveStudents?: number;

	@serializable(alias('totalStudentNotLoggedIn', primitive()))
	totalInactiveStudents?: number;

	@serializable(alias('selfStudent', primitive()))
	totalSelfOnboardStudents?: number;

	@serializable(alias('selfStudentLogin', primitive()))
	totalSelfOnboardActiveStudents?: number;

	@serializable(alias('selfStudentNotLoggedIn', primitive()))
	totalSelfOnboardInactiveStudents?: number;

	@serializable(alias('instStudent', primitive()))
	totalInstituteStudents?: number;

	@serializable(alias('instStudentLogin', primitive()))
	totalInstituteActiveStudents?: number;

	@serializable(alias('instStudentNotLoggedIn', primitive()))
	totalInstituteInactiveStudents?: number;
}